import React from 'react';
import { useLocation } from 'react-router-dom';
import { 
  HomeOutlined, 
  AppstoreOutlined, 
  SearchOutlined
} from '@ant-design/icons';
import './MobileBottomNav.css';

const MobileBottomNav: React.FC = () => {
  const location = useLocation();

  const navItems = [
    {
      key: 'home',
      icon: <HomeOutlined />,
      label: 'Home',
      path: '/'
    },
    {
      key: 'category',
      icon: <AppstoreOutlined />,
      label: 'Category',
      path: '/category/1'
    },
    {
      key: 'search',
      icon: <SearchOutlined />,
      label: 'Search',
      path: '/search'
    }
  ];

  return (
    <div className="mobile-bottom-nav">
      <div className="nav-container">
        {navItems.map(item => (
          <a
            key={item.key}
            href={item.path}
            className={`nav-item ${location.pathname === item.path || (item.key === 'category' && location.pathname.startsWith('/category/')) ? 'nav-item-active' : ''}`}
          >
            <div className="nav-icon">
              {item.icon}
            </div>
            <span className="nav-label">{item.label}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default MobileBottomNav;
